import React from 'react'
import Styled from 'styled-components'

import Link from 'components/Link'
import Icon from 'components/Icon'

const Container = Styled.div`
  position: relative;
  height: 0;
  padding-bottom: calc(100% / (4 / 3));
`

const Card = Styled(Link)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed ${props => props.theme.colors.gray.shade200};
  color: ${props => props.theme.colors.gray.shade200}
  border-radius: ${props => props.theme.radius};
  transition: 300ms;

  &:hover {
    border-color: ${props => props.theme.colors.gray.shade300};
    color: ${props => props.theme.colors.gray.shade300};
  }
`

const IconExtended = Styled(Icon)`
  font-size: 3rem;
  margin: 0 0 0.75rem 0;
`

const Label = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
`

export default ({ to, liga, label }) => (
  <Container>
    <Card to={to}>
      <IconExtended liga={liga} />
      <Label>{label}</Label>
    </Card>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/AddCard/index.js